
import React, { useEffect, useState } from 'react'
import axios from 'axios';
import baseUrl from "../BaseUrl";
import Loader from "../Loader";
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import formatDateTimeToPST from "../PSTDateConvert";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";
 
const PublishManagement = () => {

    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [role, setRole] = useState('');
    const [popupOpen, setPopupOpen] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedStatus,setSelectedStatus] = useState("");
    const [company, setCompany] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [batchList, setBatchList] = useState([]);
    const [access, setAccess] = useState([]);
    const [page, setPage] = useState(1);

    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
        getUserAccess();
        getUserCompany();
    }, []);

    useEffect(() => {
        if(role > 2){
            checkAccess();
        }
    }, [role]);

    useEffect(() => {
        getBatchList(page, selectedStatus, selectedValue);
    }, [page]);

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setRole(decoded.role);
            setName(decoded.name);
            setExpire(decoded.exp);
        } catch (error) {
           
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }

    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            setAccess(response.data.results);
            // setIsLoading(false);
            
        } catch (error) {
           console.log(error);
        //    setIsLoading(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    const checkAccess = async () => {
        navigate('/dashboard');
    }

    const getUserCompany = async () => {
        
        const response = await axiosJWT.get(`${baseUrl}/active-user-company`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const allArray = response.data.filter(item => item.id !== 1);
        setCompany(allArray);
    }

    const getBatchList = async (page, status, cid) => {
        setPopupOpen(true);
        const response = await axiosJWT.get(`${baseUrl}/get-enrms-batch-list?page=${page}&status=${status}&cid=${cid}&limit=${20}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        setPopupOpen(false);
        setBatchList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }
    const handleCompanyChange = (e) => {
        setSelectedValue(e.target.value);          
    };
    const handleSearchSubmit = () => {
        setPage(1);
        getBatchList(1, selectedStatus, selectedValue);
        // selectedStatus()
    };

    const clearFilter = () => {
        setPage(1);
        setSelectedValue("");
        setSelectedStatus("");
        getBatchList(1, "", "");
        
    };

    const handlePublishBatch = async (event, index, id) => {
        const { name, checked } = event.target;
        setBatchList((prevSetting) => {
            const updatedFormData = [...prevSetting];
            updatedFormData[index] = {
                ...updatedFormData[index], // Spread the existing fields of the object
                [name]: checked ? 2 : 1,  // Update the specific field based on 'checked' value
            };
            return updatedFormData;
        });
       
       const action = checked ? 2 : 1;
        try {
            await axios.get(`${baseUrl}/enrm-batch-publish/${id}?action=${action}`,{headers: {
                Authorization: `Bearer ${token}`
            }});
            getBatchList(page, selectedStatus, selectedValue);
            // window.location.reload();
        } catch (error) {
            console.log(error);
        }
    }

    const handleStoprunningBatch = async (e,id) => {
        e.preventDefault();
        try {
            await axios.get(`${baseUrl}/enrm-batch-stop/${id}`,{headers: {
                Authorization: `Bearer ${token}`
            }});
            // window.location.reload();
            getBatchList(page, selectedStatus, selectedValue);
        } catch (error) {
            console.log(error);
        }
    }

    const handleRemoveBatch = async(e, id) => {
        e.preventDefault();
        if (window.confirm("Are you sure you want to remove this batch?")) {
            try {
                await axios.get(`${baseUrl}/enrm-batch-remove/${id}`,{headers: {
                    Authorization: `Bearer ${token}`
                }});
                // window.location.reload();
                getBatchList(page, selectedStatus, selectedValue);
            } catch (error) {
                console.log(error);
            }
        }
    }

    const handleYouMailRetry = async (e, batchId) => {
        e.preventDefault();
        if (window.confirm("Retry YouMail for numbers with missing scan_risk_level?")) {
            try {
                await axiosJWT.get(
                    `${baseUrl}/rerun-youmail-missing-records?batch_id=${batchId}`,
                    { headers: { Authorization: `Bearer ${token}` }}
                );
                getBatchList(page, selectedStatus, selectedValue);
            } catch (error) {
                if (error.response?.status === 400) {
                    alert(error.response.data.msg);
                } else {
                    alert("Failed to retry YouMail");
                }
            }
        }
    }

    const handleResetAllBatches = async(e) => {
        e.preventDefault();

        if(window.confirm("Are you sure you want to reset all batches?")){
            setButtonDisabled(true);
            setPopupOpen(true);
            try {
                await axiosJWT.get(`${baseUrl}/enrm-reset-all-batches`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                getBatchList(1, "", "");
            } catch (error) {
                console.error("Error resetting batches:", error);
                const msg = error.response?.data?.msg || "Failed to reset batches. Please try again.";
                alert(msg);
            }
            setButtonDisabled(false);
            setPopupOpen(false);
        }
    }
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    return (
        <div className="panelbox">
            <Navbar token={token} access={access}/>
            <div className="right-panel">
                <Header name={name} />
                {popupOpen && (
                    <Loader /> 
                ) }
                <div className="content-page admin-attendance-page">
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title">
                                <h1>Publish Management</h1>
                            </div>
                        </div>
                        <div className="col-6 top-right-buttons">
                            <div className="addnew-button">
                                <Link to="/enrms-management"><span>&larr;</span> Back</Link>
                            </div>
                            <div className="export-btn newrow"><a className={buttonDisabled ? 'newrow disabled-link' : 'newrow'} onClick={handleResetAllBatches} href="#">Reset All Batches</a></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8 order-filter">
                            <div className="boxinput">
                            
                                
                            <select name="" id=""  value={selectedValue} onChange={(e) => handleCompanyChange(e)}>
                                    <option value="">Select Company</option>
                                    {company.map((comp) => ( 
                                            <option key={comp.id} value={comp.id}>
                                                {comp.cname}
                                            </option>  
                                        ))}
                                </select>
                                <select className="form-control" name='carrierStatus' value={selectedStatus} onChange={(e)=>{setSelectedStatus(e.target.value)}}>
                                        <option value=''>Select Status</option>
                                        <option value='1'>Running</option>
                                        <option value='2'>Complete</option>
                                        
                                    </select>
                                
                                <button  className="search-btn" onClick={handleSearchSubmit}>Search</button>
                               { ( selectedStatus || selectedValue ) && (<a className='search-btn clear-btn' onClick={clearFilter} >Clear</a>)}
                            </div>
                        </div>
                    </div>
                    <div className="common-white-shadow-background setting-section">
                            <div className="setting-section haft-whitebox">
                                <table className="tablebox search-result-table inventory-table device-management-table">
                                    <thead>
                                    <tr>
                                        <th>Batch Id</th>
                                        <th>Date (UTC)</th>
                                        <th>Company</th>
                                        <th>Group</th>
                                        <th>Report Type</th>
                                        <th>Total Number</th>
                                        <th>Process Number</th>
                                        <th>Status</th>
                                        <th>Unknowns</th>
                                        <th>Speed Level</th>
                                        <th>YouMail Retry</th>
                                        {role <= 2 && <th>Publish</th>}
                                        {role < 2 && <th>Action</th>}
                                        
                                        
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {batchList.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.batch_id}</td>
                                            <td>{formatDateTimeToPST(item.date, "UTC", 2)}</td>
                                            <td>{item.cname}</td>
                                            <td>{item.status == 1 ? item.group_name : "-"}</td>
                                            <td>{item.report_type == 1 ? "ENRMS" : (item.report_type == 2 ? "Basic NRMS" : (item.report_type == 3 ? "E-Only NRMS" : "-"))}</td>
                                            <td>{item.total_number}</td>
                                            <td>{item.processed_entries}/{item.total_expected}</td>
                                            <td>
                                                {item.status == 1 && <a href="#" className='newrow' onClick={(e) => handleStoprunningBatch(e,item.batch_id)} >Stop</a>}
                                                {item.status != 1 && "Complete"}
                                            </td>
                                            <td>
                                                {item.status === 1 ? (
                                                    item.batch_run_count === 1 ? "-" :
                                                    item.batch_run_count === 2 ? "1st time" :
                                                    item.batch_run_count === 3 ? "2nd time" :
                                                    item.batch_run_count === 4 ? "3rd time" :
                                                    "-"
                                                ) : "-"}
                                            </td>
                                            <td>{item.status == 1 ? `Level ${item.speed_level || 1}` : '-'}</td>
                                            <td>
                                                {(item.report_type === 1 || item.report_type === 2) ?
                                                    (item.youmail_retry_status === 1 ? (
                                                        <span className="inprogress-status">In Progress...</span>
                                                    ) : item.has_missing_scan_risk === 1 ? (
                                                        <a href="#" className="newrow" onClick={(e) => handleYouMailRetry(e, item.batch_id)}>Retry</a>
                                                    ) : (
                                                        "-"
                                                    ))
                                                : "-"}
                                            </td>
                                            {role <= 2 &&<td>
                                            <div className="switchbtn">
                                                            <input type="checkbox" id={`action-${index}`}  className="checkbox"   checked={item.publish_type == 2} name="publish_type" onChange={(e) => handlePublishBatch(e,index,item.batch_id)} /> <label
                                                                htmlFor={`action-${index}`} className="toggle">
                                                                <p>
                                                                </p>
                                                            </label>
                                                        </div>
                                            </td>}
                                            {role < 2 && <td><a href='#'><img src="images/delete.png" onClick={event => handleRemoveBatch(event, item.batch_id)} alt="" /></a></td>}
                                            
                                            
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                
                            </div>
                            {totalItem > 20 && (<Pagination
                                  activePage={page}
                                  itemsCountPerPage={20}
                                  totalItemsCount={totalItem}
                                  pageRangeDisplayed={5}
                                  onChange={handlePageChange.bind(this)}
                                />)}
                        </div>
                </div>
        
            </div>
            </div>
    )
}
 
export default PublishManagement
